import { Check, LucideIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

export enum StepStatus {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  LOCKED = 'LOCKED',
}

export interface SetupStep {
  label: string
  status: StepStatus
  /** Stands in for the status dot, where a step is worth marking out. */
  icon?: LucideIcon
}

/** The application's stepper, redrawn here so the flow can be reshaped. */
export function SetupProgress({ steps }: { steps: SetupStep[] }) {
  return (
    <div className="flex flex-col gap-5">
      {steps.map((step) => (
        <div
          key={step.label}
          className={cn(
            'flex items-center gap-3 text-xs font-semibold',
            step.status === StepStatus.IN_PROGRESS ? 'text-ink' : 'text-ink-600'
          )}
        >
          <span className="flex size-4 items-center justify-center">
            {step.icon ? (
              <step.icon className="text-ink-300 size-4" />
            ) : step.status === StepStatus.COMPLETED ? (
              <Check className="text-ink size-4" />
            ) : (
              <span
                className={cn(
                  'rounded-full',
                  step.status === StepStatus.IN_PROGRESS ? 'bg-ink size-1.5' : 'bg-ink-300 size-1.5'
                )}
              />
            )}
          </span>
          {step.label}
        </div>
      ))}
    </div>
  )
}
